import React from "react";
import { IoAdd } from "react-icons/io5";
import InvoiceList from "../Invoice/List.js";
import InvoiceForm from "./Form.js";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { hasPermission } from "../../../../utils/permission.js";

const PlusIcon = () => <IoAdd className="icon" aria-hidden="true" />;

function Invoice() {
  const listPermission = hasPermission("work-types", "view");
  return (
    <div className="projects-page">
      <header className="page-header-projects">
        <div className="header-text-content">
          <h1>Invoices</h1>
          <p>View and manage all company invoices.</p>
        </div>
        <NavLink to="/invoices/new">
          <button className="create-project-button-header">
            <PlusIcon /> Create New Invoice
          </button>
        </NavLink>
      </header>
      {listPermission ? (
        <InvoiceList />
      ) : (
        <>You do not have permission to view this.</>
      )}
    </div>
  );
}

export const InvoiceFormPage = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const createPermission = hasPermission("invoice", "create");
  const updatePermission = hasPermission("invoice", "set");
  if (id == "new") {
    if (!createPermission) {
      alert("You do not have permission to view this page.");
      navigate("/invoices");
      return null;
    }
    id = null;
  } else {
    if (!updatePermission) {
      alert("You do not have permission to view this page.");
      navigate("/invoices");
      return null;
    }
  }
  return (
    <div className="projects-page">
      <NavLink to="/invoices">
        <button className="backbutton">Back To Invoices</button>
      </NavLink>
      <InvoiceForm rowId={id} />
    </div>
  );
};

export default Invoice;
